export default __webpack_public_path__ + "images/question-overlay.svg";